export class UserModel {
  email: string;
  phoneNumber: string;
  givenName: string;
  surname: string;
  roleName: string;
  organizationId: string;
  companyPhoneNumber: string;
  companyEmail: string;
  id: string;
  identityTtype: number;
  identityNo: string;
  permitNo: string;
}

export class identityTypes {
   id : number;
   name: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/user-model.ts